export default {
  name: "pro",
  methods: {
    directionClass() {
      if (this.$store.state.locale == 'ar') return 'directionRight row'
      else return 'directionLeft row'
    }
  }
};
